import { FC } from 'react'
import {
  DropDownList,
  DropDownListChangeEvent,
  DropDownListProps
} from '@progress/kendo-react-dropdowns'

import { useAppSelector } from '../../stores'

interface SimulationModeDropDownListProps
  extends Omit<
  DropDownListProps,
  'data' | 'dataItemKey' | 'textField' | 'onChange'
  > {
  /** CODE */
  defaultValue?: string
  /** CODE */
  value?: string
  /**
   * @param value CODE
   */
  onChange?: (value: string) => void
}

export const SimulationModeDropDownList: FC<
SimulationModeDropDownListProps
> = ({ defaultValue, value, onChange, ...restProps }) => {
  const common = useAppSelector((x) => x.common)
  const codeNames = common.initialData.codeNames('YA01')

  const createValue = (codeValue?: string) => {
    if (codeValue === undefined) {
      return null
    }

    const value = codeNames.find((codeName) => codeName.CODE === codeValue)

    return value === undefined ? null : value
  }

  const handleOnChange = (event: DropDownListChangeEvent) => {
    onChange?.(event.value.CODE)
  }

  return (
    <DropDownList
      {...restProps}
      data={codeNames}
      dataItemKey="CODE"
      textField="NAME"
      defaultValue={createValue(defaultValue)}
      value={createValue(value)}
      onChange={handleOnChange}
    />
  )
}
